import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_CONCEPTOS,
  ALL_CONCEPTOS,
  LOADING_ALL_CONCEPTOS,
} from './ConceptosReducer';
import {
  deleteConceptosService,
  allConceptosService,
  oneConceptosService,
  saveConceptosService,
} from './ConceptosService';

export const allConceptosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_CONCEPTOS, payload: true });
    const res = await allConceptosService(params);
    dispatch({ type: ALL_CONCEPTOS, payload: res.data });
    dispatch({ type: LOADING_ALL_CONCEPTOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_CONCEPTOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveConceptosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveConceptosService(id, data);
    notify(res.data.message);
    await allConceptosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoConceptosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_CONCEPTOS, payload: data });
};

export const oneConceptosAction = async (dispatch, id) => {
  try {
    const res = await oneConceptosService(id);
    await setActivoConceptosAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteConceptosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteConceptosService(id);
    await setActivoConceptosAction(dispatch, null);
    notify(res.data.message);
    await allConceptosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
